<template>
  <div>
    <div class="menuManagement-title">
      {{ $t("MenuManagement.menuManagement") }}
    </div>

    <div class="menuManagement-top">
      <Select
        v-model="companyId"
        filterable
        :placeholder="$t('alarms.common.pleaseSelectCompany')"
        :transfer="true"
        @on-change="changeCompany"
        style="width:200px;float:left"
      >
        <Option :value="item.id" v-for="item in companyList" :key="item.id">{{
          item.name
        }}</Option>
      </Select>
      <add-menu-management></add-menu-management>
    </div>
    <table-menu-management
      v-if="flag"
      ref="tableMenu"
      :companyId="companyId"
    ></table-menu-management>
  </div>
</template>

<script>
import { getCookie } from "../../../../utils/cookieUtil";
import AddMenuManagement from "../menu_management/AddMenuManagement";
import TableMenuManagement from "../menu_management/TableMenuManagement";
export default {
  name: "MenuManagement",
  components: {
    AddMenuManagement,
    TableMenuManagement
  },
  data() {
    return {
      companyList: [],
      companyId: "",
      flag: false
    };
  },
  methods: {
    changeCompany(data) {
      this.companyId = data;
      //   this.$refs.tableMenu.getMenuManagementData();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
          this.companyId = this.companyList[0].id;
          this.flag = true;
        });
    }

    // this.$refs.tableMenu.getMenuManagementData();
  },
  mounted() {
    this.getCompanyDropDownBox();
  }
};
</script>

<style scoped>
.menuManagement-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
}
.menuManagement-top {
  padding: 4px 0px 15px 0px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/menu_management/MenuManagement.vue